import type { FunctionComponent } from "react";

interface IconYtProps {
  color?: string;
}

const IconYt: FunctionComponent<IconYtProps> = ({ color = "#000000" }) => {
  return (
    <svg viewBox="0 0 178 126" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M70.6 89.4001V36.7001L116.9 63.0001L70.6 89.4001ZM173.7 20.1001C171.7 12.4001 165.6 6.4001 158 4.3001C144.2 0.600096 88.7 0.600098 88.7 0.600098C88.7 0.600098 33.2 0.600096 19.4 4.3001C11.8 6.4001 5.8 12.4001 3.7 20.1001C-2.38419e-07 34.0001 0 63.0001 0 63.0001C0 63.0001 -2.38419e-07 92.1001 3.7 106C5.7 113.7 11.8 119.7 19.4 121.8C33.2 125.5 88.7 125.5 88.7 125.5C88.7 125.5 144.2 125.5 158 121.8C165.6 119.7 171.6 113.7 173.7 106C177.4 92.1001 177.4 63.0001 177.4 63.0001C177.4 63.0001 177.4 34.0001 173.7 20.1001Z"
        fill={color}
      />
    </svg>
  );
};

export default IconYt;
